import { Injectable } from '@angular/core';

import { groupBy } from 'lodash-es';

import { MyBetsBetSlip } from '../../../my-bets-base/models/my-bets-viewmodels';

export class MyBetsGroup {
    dateKeyGroup: string | null;
    columnsArray: BetListColumn[];
}

export interface BetListColumn {
    id: number;
    betslipsCount: number;
    betslips: MyBetsBetSlip[];
}

@Injectable()
export class MyBetsColumnsService {
    getGroups(columns: number, betslips: MyBetsBetSlip[], hasDateSeparators: boolean): MyBetsGroup[] {
        const myBetsGroups = [];

        if (hasDateSeparators) {
            const grouped = groupBy(betslips, 'dateKey');

            for (const i of Object.keys(grouped)) {
                this.setColumnId(grouped[i], columns);
                const mySettledBetsGroup = new MyBetsGroup();
                mySettledBetsGroup.dateKeyGroup = i;
                mySettledBetsGroup.columnsArray = this.getColumnArray(columns, betslips, i);
                myBetsGroups.unshift(mySettledBetsGroup);
            }

            return myBetsGroups;
        }
        const myBetsGroup = new MyBetsGroup();
        this.setColumnId(betslips, columns);
        myBetsGroup.columnsArray = this.getColumnArray(columns, betslips, undefined);
        myBetsGroups.push(myBetsGroup);

        return myBetsGroups;
    }

    private setColumnId(betslips: MyBetsBetSlip[], columns: number): void {
        let prevDateKey = 0;

        betslips.forEach((element, i) => {
            element.showDate = prevDateKey !== element.dateKey;
            element.columnId = (i + 1) % columns || columns;
            prevDateKey = element.dateKey;
        });
    }

    private getColumnArray(columns: number, betslips: MyBetsBetSlip[], datekey?: string): BetListColumn[] {
        const colsArr = Array.from(new Array(columns)).map((x, i) => i + 1);

        return colsArr.map((c) => {
            const filtered = datekey
                ? betslips.filter((b) => b.columnId === c && datekey === b.dateKey.toString())
                : betslips.filter((b) => b.columnId === c);

            return {
                id: c,
                betslipsCount: filtered.length,
                betslips: filtered,
            };
        });
    }
}
